module.exports = __webpack_public_path__ + "static/media/spinner.1d3b02cc.svg";